import { createVanIconComponent } from "./van"

const CreditPay = createVanIconComponent("credit-pay")
export default CreditPay
